<template>
  <div class="black_panel_cla">
    <div class="header-button-bar">
      <zk-button-group :toolBar="true" @add="add"></zk-button-group>
    </div>
    <zk-tree-grid
      :items="resourceTreeData"
      :expanded="false"
      :columns="columns"
    >
    </zk-tree-grid>
    <add-or-update-resource
      @queryUserResourceTree="queryUserResourceTree"
      @dioClose="dioClose"
      :visible="dialogFormVisible"
      :treeData="resourceTreeData"
      :form="row"
      :isUpdate="isUpdate"
    ></add-or-update-resource>
  </div>
</template>
<script>
import * as resourceService from '../../../services/resource'
import { queryUserResourceTree } from '../../../services/auth'
export default {
  name: 'ZkResource',
  data() {
    let _self = this
    let columns = [
      {
        title: this.$t('resource.resourceName'),
        key: 'name'
      },
      {
        title: this.$t('resource.sortNo'),
        key: 'sortNo'
      },
      {
        title: 'id',
        key: 'id'
      },
      // {
      //   title: this.$t('common.i18nKey'),
      //   key: 'i18nKey'
      // },
      {
        title: 'url',
        key: 'url'
      },
      {
        title: this.$t('resource.resourceEvent'),
        key: 'resourceEvent'
      },
      {
        title: this.$t('resource.resourceType'),
        key: 'resourceType',
        render: (h, params) => {
          return h('zk-dictionary-transform', {
            props: {
              value: params.column.resourceType,
              type: 'resourceType'
            }
          })
        }
      },
      {
        title: this.$t('common.status'),
        key: 'status',
        render: (h, params) => {
          return h('zk-dictionary-transform', {
            props: {
              value: params.column.status,
              type: 'status'
            }
          })
        }
      },
      {
        title: this.$t('common.operation'),
        align: 'center',
        render: (h, params) => {
          return h('zk-operate-bar', {
            props: {
              isTextBtn: true
            },
            on: {
              update() {
                _self.row = params.column
                _self.update()
              },
              remove() {
                _self.row = params.column
                _self.remove()
              }
            }
          })
        }
      }
    ]
    return {
      columns,
      row: {},
      isUpdate: false,
      dialogFormVisible: false,
      resourceTreeData: []
    }
  },
  components: {},
  methods: {
    add() {
      this.row = {}
      this.isUpdate = false
      this.dialogFormVisible = true
    },
    update() {
      if (this.row.id === '0' || this.row.id === '00000000001') {
        this.$message.error(this.$t('resource.notUpdateRoot'))
        return
      }
      this.dialogFormVisible = true
      this.isUpdate = true
    },
    dioClose() {
      this.dialogFormVisible = false
    },
    remove() {
      let _self = this
      if (_self.row.id === '0' || this.row.id === '00000000001') {
        this.$message.error(this.$t('resource.notDeleteRoot'))
        return
      }

      this.$confirm(
        this.$t('resource.confirmDeleteTip') + this.row.name + '?',
        this.$t('common.warningNotice'),
        {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          resourceService
            .remove({
              id: _self.row.id
            })
            .then(data => {
              if (data.code === '00000000') {
                _self.$message.info(this.$t('common.successDelete'))
                _self.queryUserResourceTree()
              } else {
                _self.$message.warning(data.message)
                _self.queryUserResourceTree()
              }
            })
            .catch(data => {
              this.$message.warning(data.message)
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.cancelDelete')
          })
        })
    },
    queryUserResourceTree() {
      // 获取树形资源
      queryUserResourceTree().then(data => {
        if (data.code === '00000000') {
          if (data.payload.results.resourceTree) {
            this.resourceTreeData = [data.payload.results.resourceTree]
            this.$root.menus = data.payload.results.resourceTree.children || []
            this.$root.resourceTree = data.payload.results.resourceTree
          }
          this.row = {}
        } else {
          this.$Notice.error({
            title: this.$t('common.errorNotice'),
            message: data.message
          })
        }
      })
    }
  },
  mounted() {
    this.queryUserResourceTree()
  }
}
</script>
<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/resource/src/main.vue